import { hrisApi, projectReportApi, dashboardApi } from "./api"

export const fetchProjectCategoriesSummary = async (all) => {
    const params = all ? { all: true } : {};
    const response = await projectReportApi.get('/dashboard/categories-summary', { params });
    if (response.data?.status) {
        return response.data.data;
    }
    throw new Error(response.data?.message || 'Failed to fetch project categories summary');
}

export const createProject = async (data) => {
    const response = await projectReportApi.post('/projects/', data);
    return response.data;
}

export const updateProject = async (projectId, data) => {
    const response = await projectReportApi.put(`/projects/${projectId}`, data);
    return response.data;
}

export const fetchPIC = async () => {
    const response = await hrisApi.get('/api/cari_karyawan_project?limit=20');
    if (response.data?.status?.toLowerCase() === 'success') {
        return response.data.data;
    }
    throw new Error(response.data?.message || 'Failed to fetch PIC data');
}

export const fetchPICByKeyword = async (keyword) => {
    if (!keyword) return fetchPIC();
    const response = await hrisApi.get(`/api/cari_karyawan_project?keyword_karyawan=${encodeURIComponent(keyword)}`);
    if (response.data?.status?.toLowerCase() === 'success') {
        return response.data.data;
    }
    return [];
}

export const fetchProjectDetail = async (projectId) => {
    const response = await projectReportApi.get(`/projects/${projectId}`);
    const data = response.data?.data;
    return Array.isArray(data) ? data[0] : data;
}

export const updateProjectTaskList = async (projectId, formattedTasks) => {
    const response = await projectReportApi.put(`/projects/${projectId}`, {
        taskList: JSON.stringify(formattedTasks),
    });
    return response.data;
}

export const uploadProjectDocumentation = async (formData) => {
    const response = await projectReportApi.post('/documentation/upload-documentation', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response.data;
}

export const deleteProjectDocumentation = async (documentationId) => {
    const response = await projectReportApi.delete(`/documentation/delete/${documentationId}`);
    return response.data;
}

export const fetchProjectDocumentation = async (projectId) => {
    try {
        const response = await projectReportApi.get(`/documentation/${projectId}`);
        return response.data.data;
    } catch (error) {
        console.error("Failed to fetch project documentation", error);
        return [];
    }
}

export const updateProjectDocumentationTaskName = async (data) => {
    const response = await projectReportApi.put('/documentation/update-taskname-documentations', data);
    return response.data;
}

export const fetchProjectsByCategory = async (categoryId) => {
    const response = await projectReportApi.get(`/dashboard/projects?categoryId=${categoryId}`);
    const apiProjects = response.data?.data?.projects || [];

    return apiProjects.map((p) => {
        const picParts = p.pic ? p.pic.replace(/"/g, '').split('-') : [];
        const picName = picParts.length > 1 ? picParts[1] : p.pic;

        return {
            id: p.id,
            title: p.projectName,
            description: p.descriptionProject || '',
            picName: picName,
            startDate: p.dateStart,
            endDate: p.dateEnd,
            progress: p.progress || 0,
            status: p.status || 'Berlangsung',
            UserNikCreated: p.UserNikCreated,
            tasks: {
                onProgress: p.taskStats?.onProgress || 0,
                waiting: p.taskStats?.waiting || 0,
                onHold: p.taskStats?.onHold || 0,
                done: p.taskStats?.done || 0,
            },
        };
    });
}

export const createProjectComment = async (data) => {
    try {
        const response = await projectReportApi.post('/comments', data);
        return response.data;
    } catch (error) {
        console.error("Failed to create project comment", error);
        return [];
    }
}

export const fetchProjectComments = async (projectId) => {
    try {
        const response = await projectReportApi.get(`/comments/${projectId}`);
        return response.data.data;
    } catch (error) {
        console.error("Failed to fetch project comments", error);
        return [];
    }
}

export const replyProjectComment = async (parentId, data) => {
    try {
        const response = await projectReportApi.put(`/comments/${parentId}`, data);
        return response.data;
    } catch (error) {
        console.error("Failed to reply project comment", error);
        return [];
    }
}

export const toggleLikeComment = async (parentId, data) => {
    try {
        const response = await projectReportApi.patch(`/comments/${parentId}/toggle-like`, data);
        return response.data;
    } catch (error) {
        console.error("Failed to toggle like on comment", error);
        return null;
    }
}

export const deleteProjectComment = async (commentId, isReply = false, parentId = null) => {
    try {
        const targetParentId = isReply ? parentId : commentId;
        const config = {
            data: isReply ? { replyId: commentId } : {},
            headers: { 'Content-Type': 'application/json' }
        };
        const response = await projectReportApi.delete(`/comments/${targetParentId}`, config);
        return response.data;
    } catch (error) {
        console.error("Failed to delete project comment", error);
        return null;
    }
}

export const fetchNoDPP = async (noDpp) => {
    try {
        const body = noDpp ? { noDpp: noDpp } : {};
        const response = await dashboardApi.post('/api/serachDpp', body);
        return response.data;
    } catch (error) {
        console.error("Failed to fetch no DPP", error);
        return [];
    }
}

export const fetchTbUserByNik = async (nik) => {
    try {
        const body = { nik: nik };
        const response = await dashboardApi.post('/api/tbuser/data', body);
        return response.data;
    } catch (error) {
        console.error("Failed to fetch tbuser by nik", error);
        return [];
    }
}

export const getUserByToken = async (token) => {
    try {
        const response = await dashboardApi.get('/api/dg_get_user', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching user:", error);
        return null;
    }
}

export const getExternalPic = async (name = null) => {
    const response = await dashboardApi.post(`/api/searchVendors?name=${name ? encodeURIComponent(name) : ''}`);
    if (response.data?.status?.toLowerCase() === 'success') {
        return response.data.data;
    }
}

export const uploadFileAttachment = async (formData) => {
    const response = await projectReportApi.post('/attachment/upload', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response.data;
}

export const deleteFileAttachment = async (id, nik) => {
    const response = await projectReportApi.delete(`/attachment/${id}/${nik}`);
    return response.data;
}

export const getFileAttachmentByProjectId = async (projectId, categoryFile) => {
    try {
        const response = await projectReportApi.get(`/attachment/projects/${projectId}/${categoryFile}`);
        return response.data.data;
    } catch (error) {
        console.error("Failed to fetch file attachment", error);
        return [];
    }
}

export const getFileAttachmentByFilename = async (fileId, filename) => {
    const response = await projectReportApi.get(`/attachment/project/${fileId}/${filename}`);
    return response.data.data;
}

export const getUserAccess = async (nik) => {
    const response = await projectReportApi.get(`/users/access?nik=${nik}`);
    return response.data;
}